export function formatMoney(
  value?: number,
  currency: string = "BRL"
): string | undefined {
  const options = { currency, style: "currency", maximumFractionDigits: 2 };
  let posfix = "";
  const isCrypto = ["BRL", "USD"].indexOf(currency) < 0;

  if (isCrypto) {
    options.style = "decimal";
    options.maximumFractionDigits = 6;
    posfix = ` ${currency}`;
  }

  if (!value) {
    return value?.toString();
  }

  try {
    const moneyFormatter = new Intl.NumberFormat("pt-BR", options);
    return value ? `${moneyFormatter.format(value)}${posfix}` : undefined;
  } catch (e: any) {
    console.warn(e);
    return `${(+value || 0).toFixed(
      options.maximumFractionDigits
    )} ${currency}`;
  }
}

export function formatPercent(
  value: number | string | undefined
): string | undefined {
  const num = +(value || "");
  return num && !isNaN(num) ? `${num.toFixed(2)}%` : undefined;
}

export function formatDate(timestamp: number): string {
  const formatter = Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });

  return formatter.format(timestamp);
}
